import type { ReactElement } from 'react';

import { MembersAndInvitesPanel } from './WorkspaceManagement';

export const WorkspaceMembersPage = (): ReactElement => (
  <MembersAndInvitesPanel />
);
